module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "LINESPACE",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“I have come for my courage,” announced the Lion, entering the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“Very well,” answered the little man; “I will get it for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("He went to a cupboard and reaching up to a high shelf took down a square green bottle, the contents of which he poured into a green-gold dish, beautifully carved. Placing this before the Cowardly Lion, who sniffed at it as if he did not like it, the Wizard said:")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“Drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“What is it?” asked the Lion.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“Well,” answered Oz, “if it were inside of you, it would be courage. You know, of course, that courage is always inside one; so that this really cannot be called courage until you have swallowed it. Therefore I advise you to drink it as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("The Lion hesitated no longer, but drank till the dish was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“How do you feel now?” asked Oz.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPI"
  }, [_vm._v("“Full of courage,” replied the Lion, who went joyfully back to his friends to tell them of his good fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—"), _c('b', [_vm._v("L. FRANK BAUM,")]), _vm._v(" "), _c('i', [_vm._v("The Wonderful Wizard of Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPF"
  }, [_vm._v("“This time for me! For me! For me! For me! For me! For me! For me!”")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—"), _c('b', [_vm._v("STEPHEN SONDHEIM,")]), _vm._v(" "), _c('i', [_vm._v("Gypsy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0